import PubSubTopics from "../../../../constants/pubSubTopics";

const selectByPubSubTopics = (isActiveView, visibleItems, topic, selectedIds) => {
  let resultIds = [];
  if (isActiveView) {
    if (visibleItems.size > 0) {
      switch (topic) {
        case PubSubTopics.selectAllItems:
          resultIds = visibleItems.map(item => item.id).toArray();
          break;
        case PubSubTopics.selectFirstItem:
          resultIds = [visibleItems.first().id];
          break;
        case PubSubTopics.selectPreviousItem: {
          const selectedIndexInVisibleItems = visibleItems.findIndex(ve => selectedIds.indexOf(ve.id) !== -1);
          if (selectedIndexInVisibleItems > 0) {
            resultIds = [visibleItems.get(selectedIndexInVisibleItems - 1).id];
          }
          break;
        }
        case PubSubTopics.selectNextItem: {
          const selectedIndexInVisibleItems = visibleItems.indexOf(
            visibleItems.filter(ve => selectedIds.indexOf(ve.id) !== -1).last()
          );
          if (selectedIndexInVisibleItems >= 0 && selectedIndexInVisibleItems < visibleItems.size - 1) {
            resultIds = [visibleItems.get(selectedIndexInVisibleItems + 1).id];
          }
          break;
        }
        case PubSubTopics.selectLastItem:
          resultIds = [visibleItems.last().id];
          break;
        case PubSubTopics.selectAllBeforeCurrentItem: {
          const selectedIndexInVisibleItems = visibleItems.findIndex(ve => selectedIds.indexOf(ve.id) !== -1);
          if (selectedIndexInVisibleItems > 0) {
            resultIds = visibleItems
              .slice(0, selectedIndexInVisibleItems)
              .map(ve => ve.id)
              .toArray();
          }
          break;
        }
        case PubSubTopics.selectAllAfterCurrentItem: {
          const selectedIndexInVisibleItems = visibleItems.indexOf(
            visibleItems.filter(ve => selectedIds.indexOf(ve.id) !== -1).last()
          );
          if (selectedIndexInVisibleItems >= 0 && selectedIndexInVisibleItems < visibleItems.size - 1) {
            resultIds = visibleItems
              .slice(selectedIndexInVisibleItems + 1)
              .map(ve => ve.id)
              .toArray();
          }
          break;
        }
        default:
          break;
      }
    }
  }
  return resultIds;
};

export { selectByPubSubTopics };
